import { env as s } from "./env.js";
function u(r) {
  return s.isServer ? null : r instanceof Node ? r.ownerDocument : r != null && r.hasOwnProperty("current") && r.current instanceof Node ? r.current.ownerDocument : document;
}
export {
  u as getOwnerDocument
};
